class collabsibleRow extends HTMLElement {
    constructor() {
        super();
        this.content = this.querySelector('.accordion-content');
        this.heading = this.querySelector('.accordion-header');
        this.heading.addEventListener('click', this.onClick.bind(this));
    }

    static get observedAttributes() {
        return ['open'];
    }

    setHeight() {
        if (this.hasAttribute('open')) {
            this.content.style.height = `${this.content.scrollHeight}px`;
        }
    }

    open() {
        this.setAttribute('open', '');

        this.content.style.height = `${this.content.scrollHeight}px`
        // then set height to auto after animation
        this.content.addEventListener('transitionend', this.setHeight.bind(this)
            , {
                once: true,
            });

    }
    close() {
        this.content.style.height = `${this.content.scrollHeight}px`
        // to animate the closing of the accordion
        this.content.offsetHeight;
        // OffsetHeight is used to trigger reflow, which is necessary to start the animation
        this.content.style.height = '0px';

        this.removeAttribute('open');
    }
    onClick(event) {
        event.preventDefault();
        this.hasAttribute('open') ? this.close() : this.open();
    }
}
customElements.define('collabsible-row', collabsibleRow);